export default "__VITE_ASSET__CBya4PzO__"